import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-12 px-4 text-center bg-navy-950 border-t border-navy-800" data-id="element-59">
        <div className="max-w-4xl mx-auto space-y-4" data-id="element-60">
          <p className="text-navy-600 text-sm" data-id="element-61">
            © {new Date().getFullYear()} Sueño y Serenidad. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center justify-center gap-6 text-sm" data-id="element-62">
            <button onClick={() => setActiveModal('privacy')} className="text-navy-500 hover:text-gold-400 transition-colors underline underline-offset-4 focus:outline-none focus:ring-2 focus:ring-gold-500 focus:ring-offset-2 focus:ring-offset-navy-950 rounded px-2 py-1" data-id="element-63">
              Política de Privacidad
            </button>
            <span className="text-navy-700" data-id="element-64">•</span>
            <button onClick={() => setActiveModal('terms')} className="text-navy-500 hover:text-gold-400 transition-colors underline underline-offset-4 focus:outline-none focus:ring-2 focus:ring-gold-500 focus:ring-offset-2 focus:ring-offset-navy-950 rounded px-2 py-1" data-id="element-65">
              Términos de Servicio
            </button>
          </div>
        </div>
      </footer>

      {/* Modal de Política de Privacidad */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-66">
        <div className="prose prose-navy max-w-none space-y-6" data-id="element-67">
          <p className="text-sm text-navy-600" data-id="element-68">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <section data-id="element-69">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-70">
              Información que Recopilamos
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-71">
              Cuando compras el Libro Digital Sueño y Serenidad, recopilamos la
              información necesaria para procesar tu pedido, incluyendo tu
              nombre, dirección de correo electrónico e información de pago.
              Utilizamos procesadores de pago seguros para manejar todas las
              transacciones.
            </p>
          </section>

          <section data-id="element-72">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-73">
              Cómo Usamos Tu Información
            </h3>
            <p className="text-navy-700 leading-relaxed mb-3" data-id="element-74">
              Usamos la información que recopilamos para:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-navy-700" data-id="element-75">
              <li data-id="element-76">Entregar tu producto digital</li>
              <li data-id="element-77">Enviar confirmaciones de pedido y recibos</li>
              <li data-id="element-78">Proporcionar soporte al cliente</li>
              <li data-id="element-79">
                Enviar actualizaciones ocasionales sobre el producto (puedes
                darte de baja en cualquier momento)
              </li>
            </ul>
          </section>

          <section data-id="element-80">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-81">
              Seguridad de Datos
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-82">
              Nos tomamos en serio la seguridad de tu información personal.
              Utilizamos cifrado y medidas de seguridad estándar de la industria
              para proteger tus datos. La información de pago se procesa a
              través de procesadores de pago seguros y compatibles con PCI, y
              nunca se almacena en nuestros servidores.
            </p>
          </section>

          <section data-id="element-83">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-84">
              Servicios de Terceros
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-85">
              Utilizamos servicios de terceros de confianza para procesar pagos
              y entregar productos digitales. Estos servicios tienen sus propias
              políticas de privacidad y medidas de seguridad.
            </p>
          </section>

          <section data-id="element-86">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-87">
              Tus Derechos
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-88">
              Tienes derecho a acceder, actualizar o eliminar tu información
              personal en cualquier momento. También puedes darte de baja de las
              comunicaciones de marketing mientras sigues recibiendo correos
              electrónicos esenciales relacionados con tu pedido.
            </p>
          </section>

          <section data-id="element-89">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-90">Contacto</h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-91">
              Si tienes preguntas sobre esta Política de Privacidad, contáctanos
              a través de nuestros canales de soporte.
            </p>
          </section>
        </div>
      </Modal>

      {/* Modal de Términos de Servicio */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos de Servicio" data-id="element-92">
        <div className="prose prose-navy max-w-none space-y-6" data-id="element-93">
          <p className="text-sm text-navy-600" data-id="element-94">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <section data-id="element-95">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-96">
              Aceptación de los Términos
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-97">
              Al comprar y usar el Libro Digital Sueño y Serenidad, aceptas
              estos Términos de Servicio. Por favor léelos cuidadosamente antes
              de completar tu compra.
            </p>
          </section>

          <section data-id="element-98">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-99">
              Descripción del Producto
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-100">
              El Libro Digital Sueño y Serenidad es un producto digital diseñado
              para proporcionar orientación y estrategias para mejorar la
              calidad del sueño. Se entrega como un PDF descargable y materiales
              complementarios.
            </p>
          </section>

          <section data-id="element-101">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-102">
              Aviso Médico
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-103">
              Este producto es solo para fines informativos y educativos. No
              está destinado a diagnosticar, tratar, curar o prevenir ninguna
              condición médica. Siempre consulta con un profesional de salud
              calificado antes de hacer cambios en tu rutina de sueño,
              especialmente si tienes un trastorno del sueño diagnosticado u
              otras condiciones médicas.
            </p>
          </section>

          <section data-id="element-104">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-105">
              Política de Reembolso
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-106">
              Debido a la naturaleza digital de este producto, todas las ventas
              son finales. Sin embargo, si experimentas problemas técnicos para
              acceder a tu compra, contacta a nuestro equipo de soporte y
              trabajaremos para resolver el problema.
            </p>
          </section>

          <section data-id="element-107">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-108">
              Propiedad Intelectual
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-109">
              Todo el contenido del Libro Digital Sueño y Serenidad está
              protegido por derechos de autor. No puedes reproducir, distribuir
              o compartir los materiales sin permiso escrito. Tu compra te
              otorga una licencia personal e intransferible para usar los
              materiales en tu propio beneficio.
            </p>
          </section>

          <section data-id="element-110">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-111">
              Limitación de Responsabilidad
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-112">
              No garantizamos resultados específicos. Los resultados
              individuales pueden variar según las circunstancias personales, el
              compromiso con el programa y otros factores. No somos responsables
              de ningún daño indirecto, incidental o consecuente que surja del
              uso de este producto.
            </p>
          </section>

          <section data-id="element-113">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-114">
              Cambios en los Términos
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-115">
              Nos reservamos el derecho de actualizar estos Términos de Servicio
              en cualquier momento. El uso continuado del producto después de
              los cambios constituye la aceptación de los términos actualizados.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}